import { action } from 'mobx';
import { container, singleton } from 'tsyringe';

import type { LanguageKeyEnum, LocalizationStore } from '../stores';

@singleton()
export class LocalizationStoreFacade {
  public get originalStore() {
    return container.resolve<LocalizationStore>('localizationStore');
  }

  public get languagesList() {
    return this.originalStore.languagesList;
  }

  public get appLanguage() {
    return this.originalStore.appLanguage;
  }

  public get displayLanguage() {
    return this.originalStore.displayLanguage;
  }

  public get audioLanguage() {
    return this.originalStore.audioLanguage;
  }

  public get subTitleLanguage() {
    return this.originalStore.subTitleLanguage;
  }

  public get latinLanguage() {
    return this.originalStore.latinLanguage;
  }

  public get translation() {
    return this.originalStore.translation;
  }

  @action.bound
  public async setDisplayLanguage(value: string) {
    return await this.originalStore.setDisplayLanguage(value);
  }

  @action.bound
  public async setAudioLanguage(value: string) {
    return await this.originalStore.setAudioLanguage(value);
  }

  @action.bound
  public async setSubTitleLanguage(value: string) {
    return await this.originalStore.setSubTitleLanguage(value);
  }

  @action.bound
  public languageNativeNameByCode(code: string) {
    return this.originalStore.languageNativeNameByCode(code);
  }

  @action.bound
  public languageListForKey(key: LanguageKeyEnum) {
    return this.originalStore.languageListForKey(key);
  }

  @action.bound
  public activeLanguageByKey(key: LanguageKeyEnum) {
    return this.originalStore.activeLanguageByKey(key);
  }
}
